import { jsx } from 'panel';
import { TooltipEl } from 'common/components/tooltip';
export function template() {
  const {
    iconSize
  } = this.helpers.getIconProperties();
  const avatarSrc = this.helpers.getAvatarSrc();
  return jsx("div", {
    sel: '.container'
  }, jsx("img", {
    attrs: {
      elref: "userImg",
      align: "middle",
      src: avatarSrc
    },
    style: {
      height: "".concat(iconSize, "px"),
      width: "".concat(iconSize, "px")
    }
  }), this.helpers.isTooltipEnabled() ? jsx(TooltipEl, {
    attrs: {
      placement: this.attr("tooltip-placement")
    }
  }, this.attr("tooltip-text")) : null);
}